import { Siren } from 'lucide-react';
import type { ReactNode } from 'react';

type BrandHeaderProps = {
  eyebrow?: string;
  action?: ReactNode;
};

export function BrandHeader({ eyebrow = 'Private emergency PWA', action }: BrandHeaderProps) {
  return (
    <div className="top-bar">
      <div className="brand-lockup" aria-label="SOS Signal">
        <span className="brand-mark">
          <Siren size={22} aria-hidden="true" />
        </span>
        <div>
          <p className="eyebrow">{eyebrow}</p>
          <h1>SOS Signal</h1>
        </div>
      </div>
      {action}
    </div>
  );
}
